import script from "./SideNavComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SideNavComponent.vue?vue&type=script&setup=true&lang=js"

import "./SideNavComponent.vue?vue&type=style&index=0&id=177adcaa&lang=css"

const __exports__ = script;

export default __exports__